import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PAGE_KEY } from "./constants";
var localePt = /*#__PURE__*/_defineProperty({}, PAGE_KEY, {
  LABEL_SELECT_CATEGORY: 'Selecionar categoria: {{name}}'
});
export default localePt;